import { connect } from 'react-redux';
import CollectionPage from '../pages/CollectionPage';
import withReduxForm from 'eventbrite_design_system/form/withReduxForm';
import * as analytics from '@eb/site-analytics';
import { denormalize } from '@eb/transformation-utils';
import { transformApiImageToImageField } from '@eb/redux-image-field';

import { eventsDuck, collectionsDuck } from '@eb/redux-destination';

import {
    editCollection as editCollectionAction,
    getShareUrl as getShareUrlAction,
    saveCollectionEdits as saveCollectionEditsAction,
    followCollection as followCollectionAction,
    unfollowCollection as unfollowCollectionAction,
} from '../actions/collection';
import {
    clickOnLikeToggle as clickOnLikeToggleAction,
    clickOnSeeMoreEvents as clickOnSeeMoreEventsAction,
} from '../actions/events';
import { toggleEditMode as toggleEditModeAction } from '../actions/ui';
import { clearError as clearErrorAction } from '../actions';
import { getCreatorImage } from '../selectors';
import { formatEventDataForDisplay } from '../selectors/events';
import { getShareOptions, getQualityShareOptions } from '../utils';
import { collectionForm as collectionFormValidator } from '../validators';
import {
    FALLBACK_IMAGE,
    COLLECTION_PAGE_GA_CATEGORY,
    EDITORIAL_COLLECTION_PAGE_GA_CATEGORY,
} from '../constants';

const {
    actions: {
        addOrRemoveEventToCollection: addOrRemoveEventToCollectionAction,
        createCollection: createCollectionAction,
    },
    selectors: { getFormattedCollections },
} = collectionsDuck;

const {
    actions: { clickOnViewEvent },
} = eventsDuck;

const addTimeZone = (eventsInState, normalizedFormattedEvents) =>
    normalizedFormattedEvents.map((event) => ({
        ...event,
        timezone: eventsInState[event.id].timezone,
    }));

const { trackEventFromState } = analytics;

const _mapStateToProps = (state) => ({
    featureFlags: state.featureFlags,
    isAuthenticated: state.isAuthenticated,
    userCollections: getFormattedCollections(state),
    isOwner: state.collection.canCurate,
    isQuality: state.collection.isQuality,
    isPublic: state.collection.isPublic,
    isFollowing: state.collection.isFollowing,
    collectionId: state.collection.id,
    collectionName: state.collection.name,
    collectionSummary: state.collection.summary,
    collectionImageUrl: state.collection.imageLarge
        ? state.collection.imageLarge.url
        : FALLBACK_IMAGE,
    collectionImageArtistAttribution: state.collection.artistAttribution,
    creatorName: state.collection.creator.name,
    creatorImage: getCreatorImage(state),
    collectionUser: state.collection.creator,
    displayCreatorName: state.collection.displayCreatorName,
    displayCreatorDescription: state.collection.displayCreatorDescription,
    hasError: state.hasError,
    isLoading: state.isLoading,
    shareUrl: state.collection.shareUrl,
    hasUpcomingPagination: state.collection.isQuality
        ? false
        : !!state.events.upcoming.continuation,
    userId: state.userId,
    events: addTimeZone(
        state.events.entities,
        formatEventDataForDisplay({
            events: denormalize(
                state.events.upcoming.ids,
                state.events.entities,
            ),
            currencyFormat: state.currencyFormat,
            shareOptions: state.shareOptions,
            configureShareOptionsForApp: state.collection.isQuality
                ? getQualityShareOptions
                : getShareOptions,
            affCode: state.collection.isQuality
                ? 'ebdssbeditorialcollection'
                : 'ebcollection',
        }),
    ),
    isEventsLoading: state.events.isLoading,
    isEditMode: state.ui.isEditMode,
    initialValues: {
        ...(state.collection.imageLarge
            ? transformApiImageToImageField(
                  'imageLarge',
                  state.collection.imageLarge,
              )
            : {}),
        summary: state.collection.summary || '',
        name: state.collection.name,
    },
    trackEvent: (
        action,
        label,
        category = state.collection.isQuality
            ? EDITORIAL_COLLECTION_PAGE_GA_CATEGORY
            : COLLECTION_PAGE_GA_CATEGORY,
    ) => trackEventFromState(state, { action, label, category }),
    gaCategory: 'editorial-collection',
    gaSettings: state.gaSettings,
    isGDPRCountry: state.isGDPRCountry,
    launchCommSettingsFollowAction:
        state.featureFlags.launchCommSettingsFollowAction,
});

const _mapDispatchToProps = {
    handleViewEvent: clickOnViewEvent,
    clearError: clearErrorAction,
    handleCollectionEdit: editCollectionAction,
    onSaveEvent: clickOnLikeToggleAction,
    handleSeeMoreEvents: clickOnSeeMoreEventsAction,
    getShareUrl: getShareUrlAction,
    onAddOrRemoveEventToCollection: addOrRemoveEventToCollectionAction(
        COLLECTION_PAGE_GA_CATEGORY,
    ),
    onCreateCollection: createCollectionAction(COLLECTION_PAGE_GA_CATEGORY),
    toggleEditMode: toggleEditModeAction,
    saveCollectionEdits: saveCollectionEditsAction,
    handleFollowCollection: followCollectionAction,
    handleUnfollowCollection: unfollowCollectionAction,
};

const CollectionPageWithReduxForm = withReduxForm({
    form: 'collection',
    validate: collectionFormValidator,
    useFormHooks: true,
    enableReinitialize: true,
})(CollectionPage);

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(CollectionPageWithReduxForm);
